import React from 'react';
import { INFOBOX_DISPLAY_TYPE } from '../../../constants/enums';
import styles from './InfoBox.module.css';

const InfoBoxRow = ({ label, targetValue, deliveredValue, displayType, formatter }) => {
    if (!displayType) return null;

    const safeTargetValue = typeof targetValue === 'number' && !isNaN(targetValue) ? targetValue : 0;
    const safeDeliveredValue = typeof deliveredValue === 'number' && !isNaN(deliveredValue) ? deliveredValue : 0;

    const formatValue = (value) => (formatter ? formatter(value) : value);
    return (
        <tr>
            <td><b>{label}:</b></td>
            {displayType === INFOBOX_DISPLAY_TYPE.TARGET || displayType === INFOBOX_DISPLAY_TYPE.BOTH ? (
                <td className={styles.infoBoxValue}>{formatValue(targetValue)}</td>
            ) : (
                <td></td>
            )}
            {displayType === INFOBOX_DISPLAY_TYPE.DELIVERED || displayType === INFOBOX_DISPLAY_TYPE.BOTH ? (
                <td className={styles.infoBoxValue}>{formatValue(deliveredValue)}</td>
            ) : (
                <td></td>
            )}
        </tr>
    );
};

export default InfoBoxRow;
